import React from "react";
import PropTypes from "prop-types";
// react plugin for creating charts
// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";
import Update from "@material-ui/icons/Update";
import CircularProgress from '@material-ui/core/CircularProgress';

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import SimpleSvgIcon from "components/Card/SimpleSvgIcon.jsx";
import NumSpan from "components/NumSpan.jsx";
import CzechTimeAgo from "components/CzechTimeAgo.jsx"

class TemperatureCard extends React.Component {
	state = {
		temperature: null,
		date: null
	};

	async componentDidMount() {
		const resp = await fetch(this.props.tsURL);
		const json = await resp.json();
		this.setState({
			temperature: json[this.props.tsField],
			date: new Date(json["created_at"])
		});
	}

	render() {
		const { classes, color, label, svgFile } = this.props;
		
		return (
			<Card>
				<CardHeader color={color} stats icon>
					<CardIcon color={color}>
						<SimpleSvgIcon svgFile={svgFile} />
					</CardIcon>
					<p className={classes.cardCategory}>{label}</p>
					<h3 className={classes.cardTitle}>
						{this.state.temperature == null ? (<span>Zjišťuji...</span>) : (<NumSpan value={this.state.temperature} suffix=" &#176;C"/>)  }
					</h3>
				</CardHeader>
				<CardFooter stats>
					<div className={classes.stats}>
						{this.state.date == null ? <CircularProgress size={22} style={{margin:'0 3px 0 3px', color: '#999999'}}/> : <Update />}
						{this.state.date == null ? null : <CzechTimeAgo date={this.state.date} className={classes.timeAgo}/>}
					</div>
				</CardFooter>
			</Card>
		)
	}
}

TemperatureCard.propTypes = {
	classes: PropTypes.object.isRequired,
	color: PropTypes.string.isRequired,
	tsURL: PropTypes.string.isRequired,
	tsField: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	svgFile: PropTypes.string.isRequired
};
  
export default withStyles(dashboardStyle)(TemperatureCard);
  



// WEBPACK FOOTER //
// ./src/components/Card/TemperatureCard.jsx